import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';

@Component({
    selector: 'app-learn-more-modal',
    templateUrl: './learn-more-modal.component.html',
    styleUrls: ['./learn-more-modal.component.scss'],
    standalone: false
})
export class LearnMoreModalComponent implements OnInit {
// @Input() data: any;
selectedModuleKey: string;
introPageData: any;
  private _modalData: any;
  translate: any;
  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef,
  ) { }

  ngOnInit(): void {
     this.languageTranslateService.wordSrc$.subscribe(transData => { 
          if(Object.keys(transData).length != 0){
            this.translate = transData
          }
      })
  }
  @Input() set data(value: any) {
    if (value) {
      this.selectedModuleKey = value.moduleKey;
      this.introPageData = value.data;
    }
  }

}
